import { render, staticRenderFns } from "./GroupFilter.vue?vue&type=template&id=84b3c3a6&scoped=true"
import script from "./GroupFilter.vue?vue&type=script&lang=js"
export * from "./GroupFilter.vue?vue&type=script&lang=js"
import style0 from "./GroupFilter.vue?vue&type=style&index=0&id=84b3c3a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b3c3a6",
  null
  
)

export default component.exports